// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"146":"FSFolder","161":"FSActivity","505":"FSBase"}[chunkId] || chunkId) + "." + {"146":"3ad55ded","161":"31c2c640","505":"de4223f4","843":"4ed9a162"}[chunkId] + ".css";
};